<template>
  <router-view />
</template>

<script setup lang="ts">
/**
 * @component LandingLayout
 * @description WHAT: Concise summary of what this component does. WHY: Business or UX reason. WHEN: When it runs or reacts. HOW: Key techniques (state, props, emits).
 */
// Pas de script nécessaire pour ce layout simple
</script>
